<template>
  <v-container>
    <div class="title">Support</div>
    <div>
      For help, please contact us at support@omentum.freshdesk.com.
    </div>

  </v-container>
</template>
<script>
export default {
  name: 'Support'
}
</script>
